import React, { useState } from "react";
import {
  theme,
  Badge,
  Avatar,
  Typography,
  Button,
  Divider,
  Popover,
  Space,
} from "antd";
import {
  useTranslate,
  useLogout,
  useWarnAboutChange,
  useGetIdentity,
} from "@refinedev/core";
import {
  UserOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import { PresupuestoIcon, LogoutIcon, BoxCloseIcon } from "@/components/icon";
import { User } from "@/types/schema/schema.types";
import { ModalDeCambiosSinGuardar } from "@/components/unsaved-changes";

const { useToken } = theme;
const { Text } = Typography;

interface DropMenuProps {
  collapsed: boolean;
}

export const DropMenuUser: React.FC<DropMenuProps> = ({ collapsed }) => {
  const { warnWhen, setWarnWhen } = useWarnAboutChange();
  const { mutate: mutateLogout } = useLogout();
  const translate = useTranslate();
  const { token } = useToken();
  const { data: user } = useGetIdentity<User>();

  const contentStyle: React.CSSProperties = {
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
  };

  /** Con cambios sin guardar, el popup del admin y no el del navegador (xcons-docs#490). */
  const [cerrandoSesion, setCerrandoSesion] = useState(false);
  const handleLogout = () => {
    if (warnWhen) setCerrandoSesion(true);
    else mutateLogout();
  };
  const avisoAlCerrarSesion = (
    <ModalDeCambiosSinGuardar
      open={cerrandoSesion}
      textoSalir="Cerrar sesión sin guardar"
      onQuedarse={() => setCerrandoSesion(false)}
      onSalir={() => {
        setCerrandoSesion(false);
        setWarnWhen(false);
        mutateLogout();
      }}
    />
  );

  const content = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "1px",
        padding: "0 2px",
      }}
    >
      <Button type="text" icon={<PresupuestoIcon />} size="large">
        Mis presupuestos
      </Button>
      <Button type="text" icon={<BoxCloseIcon />} size="large">
        Mis pedidos
      </Button>
      <Button type="text" icon={<SettingOutlined />} size="large">
        Configuración
      </Button>
      <Divider style={{ margin: 0 }} />
      <Button
        danger
        type="text"
        icon={<LogoutIcon />}
        size="large"
        onClick={handleLogout}
      >
        {translate("buttons.logout", "Logout")}
      </Button>
    </div>
  );

  return (
    <>
      {avisoAlCerrarSesion}
      <Popover content={content} trigger="click" style={{ cursor: "pointer" }}>
        <Button type="link" style={{ padding: "0", width: "135px" }}>
          <Badge>
            <Avatar
              size="large"
              icon={<UserOutlined />}
              style={{
                backgroundColor: "#FFF",
                color: "rgba(0,0,0, 0.88)",
                border: "1px solid #F0F0F0",
              }}
            />
          </Badge>

          {!collapsed && (
            <Space wrap direction="horizontal" style={{ textAlign: "left" }}>
              <Text style={{ textWrap: "balance", textTransform: "capitalize" }}>
                {user?.name}
              </Text>
            </Space>
          )}
        </Button>
      </Popover>
    </>
  );
};
